import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  tabs: {
    paddingBottom: 32
  },
  tab: {
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 'bold'
  }
});

export default makeStyles(styles);
